module.exports = __webpack_public_path__ + "static/chunks/src/components/part-order-section/assets/order-section.b2bf55d7824edd295018ac86eb0c965a.webp";